/*
 * ******************************************************
 * Copyright (c) 2022 Jenke & Rauschert GbR <info@aiandor.de> - All Rights Reserved
 *
 * This file is part of a software product owned by the Jenke & Rauschert GbR.
 * Unauthorized distribution of this file is strictly prohibited.
 * ******************************************************
 */

import {Button, Tooltip} from "antd";
import {IconSet, IconType} from "./icons";

interface CustomButtonProps {
    mode: 'edit' | 'add' | 'delete' | 'more' | 'password' | 'upload' | 'save' | 'report' | 'vCard' | "visible" | "invisible" | "info" | "export",
    tooltip?: string,
    onClick?: (e: any | void) => void | any,
    disabled?: boolean,
    size?: 'small' | 'middle' | 'large',
    toolbarItem? : boolean,
    iconColor?: string,
    noBorder?: boolean,
    className?: string,
}

export function CustomButton(props: CustomButtonProps) {
    let icon: IconType
    let className

    switch (props.mode) {
        case "add":
            icon = 'add'
            className = 'button-add'
            break

        case "delete":
            icon = 'delete'
            className = 'button-delete'
            break

        case "more":
            icon = 'more'
            className = 'button-edit'
            break

        case "password":
            icon = 'password'
            className = 'button-edit'
            break

        case "upload":
            icon = 'upload'
            className = 'button-edit'
            break

        case "save":
            icon = 'save'
            className = 'button-edit'
            break

        case "report":
            icon = 'report'
            className = 'button-edit'
            break

        case "vCard":
            icon = 'vCard'
            className = 'button-edit'
            break

        case "visible":
            icon = 'visible'
            className = 'button-visibility'
            break

        case "invisible":
            icon = 'invisible'
            className = 'button-visibility'
            break

        case "info":
            icon = 'info'
            className = 'button-info'
            break

        case "export":
            icon = 'export'
            className = 'button-edit'
            break

        case "edit":
        default:
            icon = 'edit'
            className = 'button-edit'
            break
    }

    if (props.disabled == true){
        className = 'button-disabled'
    }

    if (props.toolbarItem) {
        className = "button-toolbar-item"
    }

    if (props.className) {
        className = props.className
    }

    const button =
        <Button
            className={className}
            shape={"circle"}
            children={<IconSet type={icon} />}
            style={{
                border: props.noBorder ? "none" : undefined,
                boxShadow: props.noBorder ? "none" : "border-box",
                backgroundColor: props.noBorder ? "transparent" : undefined,
                color: props.iconColor ? props.iconColor : "black",
            }}
            {...props}/>

    return props.tooltip ? (<Tooltip title={props.tooltip} placement="topRight" children={button}/>) : (button)

}

CustomButton.defaultProps = {
    icon: true,
}